import { gql } from '@apollo/client';

export const searchRewardsQuery = gql`
  query SearchRewardsQuery($qFilter: RewardRequest!) {
    searchRewards(input: $qFilter) {
      results {
        action
        dataId
        event
        id
        path
      }
    }
  }
`;

export const notificationsQuery = gql`
  query Notifications($qConference: String!, $qEvent: String!) {
    notifications(conference: $qConference, event: $qEvent) {
      callToAction
      callToActionText
      conference
      event
      id
      imageUrl
      message
      page
      status
    }
  }
`;

export const getUserCurrency = gql`
  query getUserCurrency($userId: String!) {
    getUserCurrency(userId: $userId) {
      userId
      currency
      analyticsValues {
        id
        points
      }
    }
  }
`;
